/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Elastic, Power2, Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import Event = PIXI.spine.core.Event;
import {TombstoneNoMercy} from "../../TombstoneNoMercy";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";

export class TombstoneBigWinCountUp extends BitmapWinCountUp {

    private _countUpComplete: boolean;
    private _isShowing: boolean = false;

    constructor() {
        super({
            font: {
                name: "NumbersTombstone",
                size: 50
            },
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event: GameEvent) => this.onBeforeSpinStart());
        TombstoneNoMercy.api.events.on("removeCountUpForAS", (betData: APIFeatureBetEventData) => {
            this.removeCountUpForAS()
        });
    }

    public getCountUpAnimation(from: number, to: number, duration: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._isShowing = true;
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration: duration,
                ease: from == 0 ? Power3.easeInOut : Power2.easeOut
            }),
            TweenLite.fromTo(this._countUpContainer.scale, 1,
                {x: 0.5, y: 0.5},
                {x: 1, y: 1, ease: Elastic.easeOut.config(2, 1)})
        ]);

        return timeline;
    }

    public abort(endValue: number, isAborted: boolean): Timeline | null {
        if (this._countUpComplete) {
            return null;
        }

        return super.abort(endValue, isAborted)!;
    }

    public getEndingAnimation(endValue: number): Timeline {
        Logger.logDev(`getEndingAnimation`);
        this._countUpComplete = true;
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => SlotGame.sound.playEffect(TombstoneSoundConfig.instance.COUNT_UP_BACK),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01}),
            TweenLite.fromTo(this._countUpContainer.scale, 0.9,
                {x: 1.5, y: 1.5},
                {x: 1, y: 1, ease: Elastic.easeOut.config(2, 0.75)})
        ]);
        timeline.add(TweenLite.to(this._countUpContainer.scale, 0.1, {x: 0.7, y: 0.7}));
        return timeline;
    }

    protected getAbortAnimation(endValue: number): Timeline {
        Logger.logDev(`getAbortAnimation`);
        this._isShowing = true;
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01})
        ]);

        return timeline;
    }

    private onBeforeSpinStart(): void {
        this._countUpComplete = false;
        if (this._isShowing) {
            this._isShowing = false;
            const timeline = new TimelineLite();
            timeline.add([
                TweenLite.to(this._countUp, 0.2, {alpha: 0, ease: Power2.easeIn}),
                TweenLite.to(this._countUpContainer, 0.2, {y: -100, ease: Power2.easeIn})
            ], `+=1.0`); // stay a while after count up.
            timeline.add(() => this._countUpContainer.y = 0);
        }
    }

    private removeCountUpForAS(): void {
        if (this._countUp) {
            this._countUp.alpha = 0;
        }
    }
}